import { Radio } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { WaveBars } from "./Hero";
import NewsletterForm from "./NewsletterForm";

export default function Streaming() {
  return (
    <section id="streaming" className="relative py-24 md:py-36 bg-wood border-y border-woodborder" data-testid="streaming-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="relative border border-gold/30 rounded-sm p-8 md:p-16 animate-pulse-glow overflow-hidden" data-testid="streaming-panel">
            <div
              className="absolute inset-0 pointer-events-none opacity-60"
              style={{ background: "radial-gradient(ellipse 70% 90% at 80% 10%, rgba(230,161,0,0.1) 0%, transparent 55%)" }}
            />
            <div className="relative">
              <div className="flex flex-wrap items-center gap-4 mb-8">
                <Eyebrow index="06" label="NEXT CHAPTER" />
                <span className="flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] bg-gold text-obsidian px-4 py-1.5 rounded-full font-bold" data-testid="streaming-coming-soon-badge">
                  <Radio size={12} /> COMING SOON
                </span>
              </div>

              <h2 className="font-display leading-[0.85] tracking-tight" data-testid="streaming-heading">
                <span className="block text-outline-tan text-[clamp(3rem,9vw,7.5rem)]">COBAIN</span>
                <span className="block text-cream text-[clamp(3rem,9vw,7.5rem)]">STREAMING</span>
              </h2>

              <p className="mt-6 font-editorial font-bold text-gold-bright text-xl md:text-2xl" data-testid="streaming-tagline">
                Hear it here first.
              </p>
              <p className="mt-4 max-w-xl text-sand font-light leading-relaxed">
                A home for premieres, exclusives, first-listens and special releases — straight from the source. Artists debut here. The culture hears it here. Then the world catches up.
              </p>

              <div className="mt-8 flex items-center gap-4">
                <WaveBars className="h-6" />
                <span className="font-mono text-[10px] tracking-[0.25em] text-clay">FREQUENCY RESERVED — 313 MHZ</span>
              </div>

              <div className="mt-10 max-w-lg">
                <NewsletterForm source="streaming-waitlist" buttonLabel="JOIN THE WAITLIST" testId="streaming-waitlist" />
                <p className="mt-3 font-mono text-[10px] tracking-[0.15em] text-clay">FIRST ACCESS. ANNOUNCEMENTS. NO NOISE.</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
